<template>
  <!-- app用户管理 -->
  <div class="page_padding">
    <div class="page_content" v-if="authority">
      <div class="head">
        <span></span>
        <!-- 筛选 -->
        <ul class="screening_box topAn">
          <li>
            <el-input
              placeholder="请输入用户id"
              v-model="searchForm.userId"
              @change="search"
              clearable
            >
            </el-input>
          </li>
          <li>
            <el-input
              placeholder="请输入昵称"
              v-model="searchForm.nickname"
              @change="search"
              clearable
            >
            </el-input>
          </li>
          <li>
            <span>是否在线:</span>
            <el-select
              class="selectBox"
              v-model="searchForm.isOnline"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </li>
          <li>
            <span>接收预警:</span>
            <el-select
              class="selectBox"
              v-model="searchForm.iswarn"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </li>
        </ul>
      </div>
      <!-- 列表 -->
      <div id="table_list">
        <el-table
          ref="table"
          v-load="loading"
          :data="tableData"
          style="width: 100%"
          :height="table_height"
        >
          <el-table-column label="当前状态">
            <template slot-scope="scope">
              <span style="color: #67C23A" v-if="scope.row.isOnline == 1"
                >在线</span
              >
              <span style="color: #999" v-else>离线</span>
            </template>
          </el-table-column>
          <el-table-column label="接收预警">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.iswarn"
                active-color="#525F7F"
                :active-value="1"
                :inactive-value="0"
                @change="changeWarn(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column prop="nickname" label="名称"> </el-table-column>
          <el-table-column prop="alias" label="别名"> </el-table-column>
          <el-table-column prop="userName" label="userName"> </el-table-column>
          <el-table-column prop="unionid" label="unionid"> </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <Pagination
        :total="total"
        :list="tableData"
        :page="page"
        :pageSize="pageSize"
        @change="changePage"
      />
    </div>
    <div class="null_page" v-else>没有操作权限</div>
  </div>
</template>

<script>
import mixins from "../../../mixins";

export default {
  mixins: [mixins],
  data() {
    return {
      // 搜索数据
      searchForm: {
        isOnline: "",
        userId: "",
        nickname: "",
        iswarn: ""
      },
      options: [
        { value: "", label: "全部" },
        { value: 1, label: "在线" },
        { value: 0, label: "离线" }
      ],
      options2: [
        { value: "", label: "全部" },
        { value: 1, label: "接收" },
        { value: 0, label: "不接收" }
      ]
    };
  },
  watch: {
    "searchForm.isOnline": {
      deep: true,
      handler() {
        this.search();
      }
    },
    "searchForm.iswarn": {
      deep: true,
      handler() {
        this.search();
      }
    }
  },
  methods: {
    // 获取列表
    getList() {
      if (!this.authority) return;
      this.loading = true;
      this.tableScrollTop();
      this.$http({
        url: this.$api.appUser_list,
        data: {
          isOnline: this.searchForm.isOnline,
          userId: this.searchForm.userId,
          nickname: this.searchForm.nickname,
          iswarn: this.searchForm.iswarn,
          pageIndex: this.page,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.loading = false;
        if (res.code == 0) {
          this.total = res.data.total;
          this.tableData = res.data.concent;
        }
      });
    },
    // 修改预警
    changeWarn(row) {
      this.$http({
        url: this.$api.change_warn,
        data: {
          id: row.id
        }
      }).then(res => {
        if (res.code != 0) {
          this.$hint(res.code, "err");
          row.iswarn == 1 ? (row.iswarn = 0) : (row.iswarn = 1);
        }
      });
    },
    // 搜索
    search() {
      this.page = 1;
      this.getList();
    }
  }
};
</script>

<style></style>
<style lang="less" scoped>
.screening_box {
  > li {
    display: flex;
    align-items: center;
    white-space: nowrap;
    font-size: 13px;
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/appUser.vue